module.exports = __webpack_public_path__ + "img/bilErr.84e7b12d.png";